export var ModuleConfig;
(function (ModuleConfig) {
    ModuleConfig["Advertising"] = "AdvertisingConfig";
    ModuleConfig["TownPlanning"] = "TownPlanningConfig";
    ModuleConfig["Gautrain"] = "GautrainGenericTemplateConfig";
    ModuleConfig["BuildingPlans"] = "BuildingPlansConfig";
    ModuleConfig["BuildingPlansInspectorate"] = "BuildingPlansInspectorateConfig";
    ModuleConfig["BusinessLicence"] = "BusinessLicenceConfig";
    ModuleConfig["Wayleaves"] = "WayleavesConfig";
    ModuleConfig["PropertyAndLease"] = "PropertyAndLeaseConfig";
    ModuleConfig["Cemetery"] = "CemeteryConfig";
    ModuleConfig["PropertyValuation"] = "PropertyValuationConfig";
    ModuleConfig["DemolitionManagement"] = "DemolitionManagementConfig";
    ModuleConfig["TrainingModule"] = "TrainingModuleConfig";
    ModuleConfig["ElectricalConnection"] = "ElectricalConnectionConfig";
    ModuleConfig["InformalTrade"] = "InformalTradeConfig";
    ModuleConfig["StreetNaming"] = "StreetNamingConfig";
    ModuleConfig["RatesCertificate"] = "RatesCertificateConfig";
    ModuleConfig["ZoningCertificate"] = "ZoningCertificateConfig";
})(ModuleConfig || (ModuleConfig = {}));
